import { gql } from "@apollo/client/core";

export const GET_DAY_RACETRACKS = gql`
  query DayRacetracks($date: String!) {
    dayRaceTracks(date: $date)
  }
`;
